import { Navigate, useParams } from 'react-router-dom';
import { Box } from '@mantine/core';
import PageWithSidebar from 'src/UI/page-nav/PageWithSidebar';
import { CompanyTabs } from './types';
import FundsListPage from 'src/company/funds/components/FundsListPage';
import ProvidersListPage from 'src/company/providers/components/ProvidersListPage';
import { useFlags } from 'src/feature-flags/FlagsHook';

export default function CompanyPage() {
  const { tab } = useParams<{ tab: string }>();
  const { flagEnabledProviderSources } = useFlags();

  const COMPANY_LINKS = [
    {
      label: 'Funds',
      href: '/company/funds',
    },
  ];

  if (flagEnabledProviderSources) {
    COMPANY_LINKS.push({
      label: 'Provider sources',
      href: '/company/providers',
    });
  }

  if (!tab) {
    return <Navigate to="/company/funds" replace />;
  }

  const renderContent = () => {
    switch (tab) {
      case CompanyTabs.funds:
        return <FundsListPage />;
      case CompanyTabs.providers:
        if (!flagEnabledProviderSources) {
          return <Navigate to="/company/funds" replace />;
        }
        return <ProvidersListPage />;
      default:
        return <Navigate to="/company/funds" replace />;
    }
  };

  return (
    <Box pt="xxl">
      <PageWithSidebar links={COMPANY_LINKS} activeUrl={`/company/${tab}`}>
        {renderContent()}
      </PageWithSidebar>
    </Box>
  );
}
